export default __webpack_public_path__ + "static/media/WWYK.fc881d00.gif";